import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AllFavDrugs {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  AllFavDrugsData?: any;
  Items?: any;
  Pagination?: any;
}

const initialState: AllFavDrugs = {
  isLoading: false,
  error: false,
  message: null,
  AllFavDrugsData: [],
  Items: [],
  Pagination: [],
};

const FavDrugsSlice = createSlice({
  name: "favdrugs",
  initialState,
  reducers: {
    loadingAllFavDrugs: (state: AllFavDrugs, action: PayloadAction<{}>) => {
      state.isLoading = true;
    },
    setAllFavDrugs: (state: any, action: PayloadAction<AllFavDrugs>) => {
      return action.payload;
    },
    clearData: (state: AllFavDrugs, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const { loadingAllFavDrugs, setAllFavDrugs, clearData } =
  FavDrugsSlice.actions;

export default FavDrugsSlice.reducer;
